import { createElementBlock as l, openBlock as r, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return r(), l("svg", o, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 7.333C1 5.45 2.586 4 4.444 4h15.111C21.414 4 23 5.45 23 7.333v2.334a1 1 0 1 1-2 0V7.333C21 6.64 20.398 6 19.555 6H4.444C3.602 6 3 6.64 3 7.333v1.334h10a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zm1 5.258a1 1 0 0 1 1 1v3.076C3 17.36 3.602 18 4.444 18h15.111c.843 0 1.445-.64 1.445-1.333V13.59a1 1 0 1 1 2 0v3.076C23 18.55 21.413 20 19.555 20H4.444C2.586 20 1 18.551 1 16.667V13.59a1 1 0 0 1 1-1M17.8 8.36c.006-.571-.772-.746-1.01-.226l-2.014 4.405c-.16.35.096.748.48.748h1.37l-.067 2.656c-.015.572.764.756 1.006.237l2.055-4.396a.528.528 0 0 0-.479-.752h-1.373z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_energy_card-Cfpo7ZqH.js.map
